import cn from 'classnames'
import React, { ComponentProps } from 'react'

type MccEducationIconProps = {
  className?: string
} & ComponentProps<'svg'>

export default function MccEducationIcon(props: MccEducationIconProps) {
  const { className = '', ...rest } = props
  return (
    <svg
      className={cn('MccEducationIcon', className)}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M14.6667 4.66658V8.66658M3.99999 6.33325V8.66658C3.99999 9.19701 4.42142 9.70572 5.17156 10.0808C5.92171 10.4559 6.93912 10.6666 7.99999 10.6666C9.06085 10.6666 10.0783 10.4559 10.8284 10.0808C11.5786 9.70572 12 9.19701 12 8.66658V6.33325M14.28 5.28125C14.3993 5.2286 14.5006 5.14209 14.5713 5.03245C14.6419 4.9228 14.6789 4.79484 14.6775 4.6644C14.6762 4.53397 14.6366 4.40679 14.5637 4.29863C14.4908 4.19048 14.3877 4.10608 14.2673 4.05591L8.55332 1.45325C8.37961 1.37401 8.19091 1.33301 7.99999 1.33301C7.80906 1.33301 7.62036 1.37401 7.44665 1.45325L1.73332 4.05325C1.61463 4.10523 1.51366 4.19067 1.44277 4.29912C1.37187 4.40758 1.33411 4.53434 1.33411 4.66391C1.33411 4.79348 1.37187 4.92025 1.44277 5.0287C1.51366 5.13716 1.61463 5.2226 1.73332 5.27458L7.44665 7.87991C7.62036 7.95915 7.80906 8.00015 7.99999 8.00015C8.19091 8.00015 8.37961 7.95915 8.55332 7.87991L14.28 5.28125Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
